import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import Icon from '../../modules/foundation/components/Icon/Icon';
import { classNames } from '../../utils/classname';
var defaultProps = {
  className: '',
  iconName: ''
};
export default function Phone(_ref) {
  var phone = _ref.phone,
    className = _ref.className,
    iconName = _ref.iconName;
  if (_isEmpty(phone)) {
    return null;
  }
  function getContent() {
    if (!_isEmpty(iconName)) {
      return /*#__PURE__*/React.createElement(Icon, {
        iconName: iconName
      });
    }
    return phone;
  }
  var finalClassName = classNames(_defineProperty({
    phone: true
  }, className, true));
  return /*#__PURE__*/React.createElement("a", {
    className: finalClassName,
    href: "tel:".concat(phone),
    "aria-label": "Call Business"
  }, getContent());
}
Phone.defaultProps = defaultProps;